import React, { useEffect, useRef } from "react";

/* ---------- Lightweight RichTextEditor (ohne deps) ---------- */
export default function RichTextEditor({
  value,
  onChange,
  placeholder = "Beschreibung …",
  mode = "full", // "full" | "comment"
  onUploadImages, // async (File[]) => string[] (URLs)
}) {
  const ref = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
  }, [value]);

  const exec = (cmd, arg = null) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
  };

  const onPaste = (e) => {
    if (!e.clipboardData) return;
    const items = e.clipboardData.items;
    const imgItems = [];
    for (let i = 0; i < items.length; i++) {
      const it = items[i];
      if (it.kind === "file") {
        const f = it.getAsFile();
        if (f && f.type.startsWith("image/")) imgItems.push(f);
      }
    }
    if (imgItems.length && onUploadImages) {
      e.preventDefault();
      onUploadImages(imgItems).then((urls) => {
        urls.forEach((u) => exec("insertImage", u));
      });
      return;
    }
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  };

  const wantImage = () => fileRef.current?.click();

  const onPickFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length || !onUploadImages) return;
    const urls = await onUploadImages(files);
    urls.forEach((u) => exec("insertImage", u));
  };

  return (
    <div className="rte">
      <div className="rte-toolbar">
        <button type="button" onClick={() => exec("bold")}>B</button>
        <button type="button" onClick={() => exec("italic")}><i>I</i></button>
        <button type="button" onClick={() => exec("underline")}><u>U</u></button>
        {mode === "full" && (
          <>
            <button type="button" onClick={() => exec("formatBlock", "h2")}>H2</button>
            <button type="button" onClick={() => exec("formatBlock", "h3")}>H3</button>
            <button type="button" onClick={() => exec("insertUnorderedList")}>• Liste</button>
            <button type="button" onClick={() => exec("insertOrderedList")}>1. Liste</button>
          </>
        )}
        <button
          type="button"
          onClick={() => {
            let url = prompt("Link-URL:");
            if (url && !/^https?:\/\//i.test(url)) url = "https://" + url;
            if (url) exec("createLink", url);
          }}
        >Link</button>
        {onUploadImages && (
          <>
            <button type="button" onClick={wantImage}>Bild</button>
            <input
              ref={fileRef}
              hidden
              type="file"
              accept="image/*"
              multiple
              onChange={onPickFiles}
            />
          </>
        )}
        <button type="button" onClick={() => exec("removeFormat")}>Format löschen</button>
      </div>

      <div
        ref={ref}
        className="rte-editor"
        contentEditable
        role="textbox"
        aria-multiline="true"
        data-placeholder={placeholder}
        onInput={() => onChange?.(ref.current?.innerHTML || "")}
        onPaste={onPaste}
        suppressContentEditableWarning
      />
    </div>
  );
}
